const monthsMap = {
  he: {
    1: "ינואר",
    2: "פברואר",
    3: "מרץ",
    4: "אפריל",
    5: "מאי",
    6: "יוני",
    7: "יולי",
    8: "אוגוסט",
    9: "ספטמבר",
    10: "אוקטובר",
    11: "נובמבר",
    12: "דצמבר",
  },

  ar: {
    1: "كانون ثاني",
    2: "شباط",
    3: "اذار",
    4: "نيسان",
    5: "ايار",
    6: "حزيران",
    7: "تموز",
    8: "آب",
    9: "أيلول",
    10: "تشرين أول",
    11: "تشرين ثاني",
    12: "كانون اول",
  },
};

export function convertMonth(month, lang) {
  return monthsMap[lang][month];
}
